import { useEffect, useRef, useState } from 'react';
import { MdOutlineEdit, MdMerge, MdBlock, MdMoreVert } from 'react-icons/md';
import { FiEye } from 'react-icons/fi';
import { Link } from 'react-router-dom';

interface CampaignActionDropdownProps {
    campaignId?: Number;
}
const CampaignActionDropdown = ({
    campaignId,
}: CampaignActionDropdownProps) => {
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [dropdownPosition, setDropdownPosition] = useState({ top: 0, right: 0 });
    const trigger = useRef<any>(null);
    const dropdown = useRef<any>(null);
    // close on click outside
    useEffect(() => {
        const clickHandler = ({ target }: MouseEvent) => {
            if (!dropdown.current) return;
            if (
                !dropdownOpen ||
                dropdown.current.contains(target) ||
                trigger.current.contains(target)
            )
                return;
            setDropdownOpen(false);
        };
        document.addEventListener('click', clickHandler);
        return () => document.removeEventListener('click', clickHandler);
    });

    // close if the esc key is pressed
    useEffect(() => {
        const keyHandler = ({ keyCode }: KeyboardEvent) => {
            if (!dropdownOpen || keyCode !== 27) return;
            setDropdownOpen(false);
        };
        document.addEventListener('keydown', keyHandler);
        return () => document.removeEventListener('keydown', keyHandler);
    });
    return (
        <>
            <div className='relative'>
                <button
                    ref={trigger}
                    onClick={(e) => {
                        if (!dropdownOpen && trigger.current) {
                            const rect = trigger.current.getBoundingClientRect();
                            setDropdownPosition({
                                top: rect.bottom + window.scrollY,
                                right: window.innerWidth - rect.right + window.scrollX
                            });
                        }
                        setDropdownOpen(!dropdownOpen);
                    }}
                >
                    <MdMoreVert className='text-primary' size={24} />
                </button>
                <div
                    ref={dropdown}
                    onFocus={() => setDropdownOpen(true)}
                    onBlur={() => setDropdownOpen(false)}
                    className={`w-78 fixed z-50 rounded-sm border border-stroke bg-white p-1.5 px-[12px] py-[12px] shadow-default dark:border-strokedark dark:bg-boxdark ${
                        dropdownOpen === true ? 'block' : 'hidden'
                    }`}
                    style={{
                        top: `${dropdownPosition.top}px`,
                        right: `${dropdownPosition.right}px`
                    }}
                >
                    <Link
                        {...(campaignId
                            ? { to: `/campaigns/${campaignId}` }
                            : { to: '#' })}
                    >
                        <button
                            type='button'
                            className='flex w-full items-center gap-[12px]'
                        >
                            <MdOutlineEdit className='text-primary' size={18} />
                            Edit
                        </button>
                    </Link>
                    <button
                        type='button'
                        className='flex w-full items-center gap-[12px]'
                        onClick={() =>
                            window.open(
                                `${
                                    import.meta.env.VITE_WP_URL
                                }/campaign/${campaignId}`,
                                '_blank'
                            )
                        }
                    >
                        <FiEye className='text-primary' size={18} />
                        View
                    </button>

                    <button
                        type='button'
                        className='flex w-full items-center gap-[12px]'
                    >
                        <MdMerge className='text-primary' size={18} />
                        Merge
                    </button>

                    <button
                        type='button'
                        className='flex w-full items-center gap-[12px]'
                    >
                        <MdBlock className='text-red' size={18} />
                        Close
                    </button>
                </div>
            </div>
        </>
    );
};

export default CampaignActionDropdown;
